import React, { Component } from "react"
import { ComboBox } from "../../ComboBox";
import { PaymentHistory } from "../PaymentHistory/PaymentHistory";
import { ModalDetailUser } from "./modal";
import { ModalMessageUser } from "./ModalMessageUser"
import './module.css'
import { TemplateScarapela } from "./templateScarapela";

export class RegisteredUsers extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false, data: [], filter: {}, userList: [], clientId: -1, isPayment: false,
            search: {
                Condition: '',
                Text: '',
                EmptyRegistry: null,
                WithoutIdentity: null
            },
            isGrid: false
        };
    }

    componentDidMount() {
        let userEmail = '';

        if (window.location.href.lastIndexOf('email') > -1) {
            userEmail = window.location.href.substring(window.location.href.lastIndexOf('/') + 1, window.location.href.length);
            document.querySelector('#searchUser').value = userEmail;
        }
        this.get(userEmail);
    }

    async get(email) {
        try {
            this.setState({ loading: true });
            var request = {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': `bearer ${localStorage.getItem('token')}`
                },
                body: email ? JSON.stringify(
                    {
                        Condition: '',
                        Text: email
                    }
                ) : JSON.stringify(this.state.search)
            }

            const response = await fetch('AdminRegisteredUsers/Get', request);

            if (response.redirected) {
                window.location.href = response.url;
            }

            if (response.status == 200) {
                var data = await response.json();
                this.setState({ data: data.client, comboProcess: data.process, Users: data.users, loading: false });
            }
        } catch (e) {
            this.setState({ loading: false });
        }
    }

    async sendUnregisteredUsers(email) {
        try {
            this.setState({ loading: true });
            var request = {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': `bearer ${localStorage.getItem('token')}`
                },
                body: email ? JSON.stringify(
                    {
                        Condition: '',
                        Text: email
                    }
                ) : JSON.stringify(this.state.search)
            }

            const response = await fetch('AdminRegisteredUsers/SendUnregisteredUsers', request);

            if (response.redirected) {
                window.location.href = response.url;
            }

            if (response.status == 200) {
                var data = await response.json();
                this.setState({ data: data.client, comboProcess: data.process, Users: data.users, loading: false });
            }
        } catch (e) {
            this.setState({ loading: false });
        }
    }

    async downloadClients(e) {
        try {

            var model = {
                Client: this.state.userList,
                ProcessType: e.currentTarget.dataset.process,
                CurrentIdProcess: document.querySelector('#comboProcessFilter select').value
            }

            this.setState({ loading: true });
            var request = {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': `bearer ${localStorage.getItem('token')}`
                },
                body: JSON.stringify(model)
            }

            const response = await fetch('AdminRegisteredUsers/DownloadUsers', request);

            if (response.redirected) {
                window.location.href = response.url;
            }

            if (response.status == 200) {
                let data = await response.json();
                window.location.href = data.path;
                this.setState({ loading: false });
            }
        } catch (e) {
            this.setState({ loading: false });
        }
    }

    async downloadClientsByProcess() {
        try {

            if (!document.querySelector('#comboProcessFilter select').value) {
                alert("Seleccione un proceso para generar el reporte.");
                return;
            }

            this.setState({ loading: true });
            var request = {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': `bearer ${localStorage.getItem('token')}`
                },
                body: null
            }

            const response = await fetch(`AdminRegisteredUsers/DownloadClientsByProcess?processId=${document.querySelector('#comboProcessFilter select').value}`, request);

            if (response.redirected) {
                window.location.href = response.url;
            }

            if (response.status == 200) {
                let data = await response.json();
                window.location.href = data.path;
                this.setState({ loading: false });
            }
        } catch (e) {
            this.setState({ loading: false });
        }
    }

    setProcessId(event) {
        this.setState({ search: { Condition: event.currentTarget.value, Text: this.state.search.Text, EmptyRegistry: this.state.search.EmptyRegistry } });
    }

    handlerUser(event) {
        this.setState({ search: { Text: event.currentTarget.value, Condition: this.state.search.Condition, EmptyRegistry: this.state.search.EmptyRegistry } });
    }

    handlerCheck(event) {
        this.setState({ search: { Text: this.state.search.Condition.Text, Condition: this.state.search.Condition, EmptyRegistry: event.currentTarget.checked } });
    }

    usersWithoutIdentity(event) {
        this.setState({ search: { Text: this.state.search.Condition.Text, Condition: this.state.search.Condition, EmptyRegistry: this.state.search.EmptyRegistry, WithoutIdentity: event.currentTarget.checked } });
    }

    async attendedMark(e) {
        //this.setState({ loading: true });

        var currentControl = e.currentTarget;
        var currentVal = e.currentTarget.checked;
        var request = {
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
                'Authorization': `bearer ${localStorage.getItem('token')}`
            },
            body: JSON.stringify({ Id: parseInt(e.currentTarget.value), [e.currentTarget.dataset.argument]: e.currentTarget.checked, Alias: 'NA' })
        }

        const response = await fetch('AdminRegisteredUsers/AttendedMark', request);

        if (response.redirected) {
            window.location.href = response.url;
        }

        if (response.status == 200) {
            currentControl.checked = currentVal;
            alert('Usuario actualizado con éxito');
        } else { alert('Error actualizando el usuario, inténtelo más tarde.'); }
        //this.setState({ loading: false });
    }

    openDetail(e) {

        var fil = this.state.data.filter((a) => { return a.id == parseInt(e.currentTarget.dataset.value) });
        this.setState({ userSelected: fil[0] })
        document.querySelector('#openModel').click();
    }

    async openModalMessage(e) {

        document.querySelector('#openModalMessage').click();

        this.setState({ /*loading: true, */clientId: parseInt(e.currentTarget.dataset.value) });
        var request = {
            method: 'GET',
            headers: {
                'Content-type': 'application/json',
                'Authorization': `bearer ${localStorage.getItem('token')}`
            }
        }

        const response = await fetch(`AdminRegisteredUsers/GetCommentByClient?clientId=${parseInt(e.currentTarget.dataset.value)}`, request);

        if (response.redirected) {
            window.location.href = response.url;
        }

        this.setState({ messages: await response.json(), loading: false })
    }

    async deleteClient(e) {

        var request = {
            method: 'GET',
            headers: {
                'Content-type': 'application/json',
                'Authorization': `bearer ${localStorage.getItem('token')}`
            }
        }

        var response = await fetch(`AdminRegisteredUsers/DeleteUser?clientId=${this.state.clientId}`, request)
        if (response.redirected) {
            window.location.href = response.url;
        }

        switch (response.status) {
            case 200:
                this.get('');
                document.querySelector('#closeConfirmDelete').click();
                alert('Usuario eliminado con éxito.');
                break;
            case 401:
                alert(`No está autorizado para eliminar usuarios, contacte al administrador`);
                break;
            case 400:
                alert(`Error eliminando el cliente`)
                break;
            default:
        }
    }

    async openModalPayments(e) {
        this.setState({ clientId: parseInt(e.currentTarget.dataset.value), isPayment: true });
    }

    handlerScarp(e) {

        var fil = this.state.data.filter((a) => {
            return this.state.userList.indexOf(a.id) > -1;
        });
        this.setState({ showScarp: fil });
    }

    print(e) {
        this.setState({ typeProcess: e.currentTarget.dataset.type, printing: true });

        document.querySelectorAll('#contentScarp .item .process').forEach((a) => { a.innerHTML = e.currentTarget.dataset.type; });

        var context = this;

        var mywindow = window.open('', 'PRINT', 'height=400,width=600');
        mywindow.document.write('<html><head>');
        mywindow.document.write('</head><body >');
        mywindow.document.write(document.getElementById('contentScarp').innerHTML);
        mywindow.document.write('</body></html>');

        setTimeout(() => {

            mywindow.document.close(); // necessary for IE >= 10
            mywindow.focus(); // necessary for IE >= 10*/

            mywindow.print();
            mywindow.close();
            context.setState({ printing: false });

        }, 1000);
    }

    async markAsist(e) {

        var model = {
            Client: this.state.userList,
            ProcessType: e.currentTarget.dataset.process,
            CurrentIdProcess: document.querySelector('#comboProcessFilter select').value
        }

        this.setState({ loading: true });

        const request = {
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
                'Authorization': `bearer ${localStorage.getItem('token')}`
            },
            body: JSON.stringify(model)
        }

        const response = await fetch('AdminRegisteredUsers/AttendedMarkMasive', request);
        this.setState({ loading: false });
        if (response.redirected) {
            window.location.href = response.url;
        }

        if (response.status == 200) {
            this.setState({ data: await response.json() });
            alert('Usuarios actualizados con éxito');
        } else { alert('error'); }
        this.setState({ loading: false });

    }

    static renderViewGrid(context) {
        function filterQuestions(key) {
            if (key) {
                var words = ['No', 'Ninguna', 'Ninguno', 'Nada', 'No Ninguna', 'No, ninguna']
                var filter = words.filter((a) => { return a.toLowerCase() == key.trim().toLowerCase() });
                return filter.length == 0 ? key : ''
            }
            return false;
        }

        if (context.state.data && context.state.data.length > 0) {
            return (

                <div className="mt-3">


                    <div className="row">
                        <div className="col-lg-1 border p-3">

                        </div>
                        <div className="col-lg-2 border p-3">
                            <b>Nombre: </b>
                        </div>
                        <div className="col-lg-2 border p-3">
                            <b>Correo: </b>
                        </div>
                        <div className="col-lg-2 border p-3">
                            <b>N&uacute;mero de contacto: </b>
                        </div>
                        <div className="col-lg-2 border p-3">
                            <b>Enrolador: </b>
                        </div>
                        <div className="col-lg-1 border p-3">
                            <b>N&uacute;mero enrolador: </b>
                        </div>
                        <div className="col-lg-2 border p-3">

                        </div>
                    </div>
                    {
                        context.state.data.map(data =>

                            <div className="result row">
                                <div className="col-lg-1 border p-3" style={{ display: 'block' }}>
                                    <input type="checkbox" class="check-user" data-value={data.id} onClick={(e) => {
                                        if (e.currentTarget.checked) {
                                            context.state.userList.push(parseInt(e.currentTarget.dataset.value))
                                        } else {
                                            context.state.userList.splice(context.state.userList.indexOf(parseInt(e.currentTarget.dataset.value)), 1)
                                        }
                                        context.handlerScarp(e);
                                    }} />

                                    {
                                        data && (data.age < 18 || data.nervousCollapse == 'Si' || data.takeMedication == 'Si' || filterQuestions(data.physicalDisability) || filterQuestions(data.questions)) ?
                                            <label className="float-right" title={data ? (`${data.age < 18 ? 'Es menor de edad' : ''} ${data.nervousCollapse == 'Si' ? 'Colapso nervios' : ''} ${data.takeMedication == 'Si' ? 'Toma medicamentos' : ''} ${filterQuestions(data.physicalDisability) ? 'Discapacitado físico' : ''} ${filterQuestions(data.questions) ? 'Tiene dudas' : ''}`) : ''} >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-info-circle-fill" viewBox="0 0 16 16">
                                                    <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" />
                                                </svg>
                                            </label>
                                            : null
                                    }
                                </div>

                                <div className="col-lg-2 border p-3">
                                    {data.name}
                                </div>
                                <div className="col-lg-2 border p-3">
                                    <a href="mailto:{data.email}">{data.email}</a>
                                </div>
                                <div className="col-lg-2 border p-3">
                                    {data.contact}
                                </div>
                                <div className="col-lg-2 border p-3">
                                    {data.enroller}
                                </div>
                                <div className="col-lg-1 border p-3">
                                    {data.enrollerNumber}
                                </div>
                                <div className="col-lg-2 border p-3">
                                    <input type="button" onClick={context.openDetail.bind(context)} data-value={data.id} className="action btn more" title="Ver más detalle" />
                                    <input type="button" onClick={context.openModalPayments.bind(context)} data-value={data.id} className="action btn paying" title="Historico de pagos" />

                                    <a data-toggle="modal" data-target="#delete" data-value={data.id} onClick={(e) => { context.setState({ clientId: data.id }) }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-trash-fill" viewBox="0 0 16 16">
                                            <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z" />
                                        </svg>
                                    </a>
                                </div>
                            </div>

                        )
                    }
                </div>

            )
        } else {
            return <div>Sin resultados, intente selecionando otra proceso.</div>;
        }
    }

    static renderDesktop(context) {

        function filterQuestions(key) {
            if (key) {
                var words = ['No', 'Ninguna', 'Ninguno', 'Nada', 'No Ninguna', 'No, ninguna']
                var filter = words.filter((a) => { return a.toLowerCase() == key.trim().toLowerCase() });
                return filter.length == 0 ? key : ''
            }
            return false;
        }

        if (context.state.data && context.state.data.length > 0) {
            return (context.state.data.map(data => <div className="result wrapp-group mt-3Seleccionar todos los usuarios">
                <div className="group" style={{ display: 'block' }}>
                    <input type="checkbox" class="check-user" data-value={data.id} onClick={(e) => {
                        if (e.currentTarget.checked) {
                            context.state.userList.push(parseInt(e.currentTarget.dataset.value))
                        } else {
                            context.state.userList.splice(context.state.userList.indexOf(parseInt(e.currentTarget.dataset.value)), 1)
                        }
                        context.handlerScarp(e);
                    }} />
                    <label> Seleccionar usuario</label>

                    {
                        data && (data.age < 18 || data.nervousCollapse == 'Si' || data.takeMedication == 'Si' || filterQuestions(data.physicalDisability) || filterQuestions(data.questions)) ?
                            <label className="float-right" title={data ? (`${data.age < 18 ? 'Es menor de edad' : ''} ${data.nervousCollapse == 'Si' ? 'Colapso nervios' : ''} ${data.takeMedication == 'Si' ? 'Toma medicamentos' : ''} ${filterQuestions(data.physicalDisability) ? 'Discapacitado físico' : ''} ${filterQuestions(data.questions) ? 'Tiene dudas' : ''}`) : ''} >
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-info-circle-fill" viewBox="0 0 16 16">
                                    <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" />
                                </svg>
                            </label>
                            : null
                    }
                </div>

                <div className="group">
                    <b>Nombre: </b>
                    <label>{data.name}</label>
                </div>
                <div className="group">
                    <b>Correo: </b>
                    <label><a href="mailto:{data.email}">{data.email}</a></label>
                </div>
                <div className="group">
                    <b>N&uacute;mero de contacto: </b>
                    <label>{data.contact}</label>
                </div>
                <div className="group">
                    <b>Enrolador: </b>
                    <label>{data.enroller}</label>
                </div>
                <div className="group">
                    <b>N&uacute;mero enrolador: </b>
                    <label>{data.enrollerNumber}</label>
                </div>
                <div className="group">
                    <b>B&aacute;sico: </b>
                    <label> {data.basicName}</label>
                    <div className="row">
                        <div className="option-va">
                            ¿Va?
                            <input type="checkbox" checked={data.basic} disabled />
                        </div>
                        <div className="option-va">
                            ¿Asisti&oacute;?
                            <input type="checkbox" checked={data.attendedBasic} onClick={context.attendedMark.bind(context)} data-argument="AttendedBasic" value={data.id} />
                        </div>
                    </div>
                </div>
                <div className="group">
                    <b>Avanzado: </b>
                    <label> {data.advanceName}</label>
                    <div className="row">
                        <div className="option-va">
                            ¿Va?
                            <input type="checkbox" checked={data.advance} disabled />
                        </div>
                        <div className="option-va">
                            ¿Asisti&oacute;?
                            <input type="checkbox" checked={data.attendedAdvence} onClick={context.attendedMark.bind(context)} data-argument="AttendedAdvence" value={data.id} />
                        </div>
                    </div>
                </div>
                <div className="group">
                    <b>Pl: </b>
                    <label> {data.plName}</label>
                    <div className="row">
                        <div className="option-va">
                            ¿Va?
                            <input type="checkbox" checked={data.pl} disabled />
                        </div>
                        <div className="option-va">
                            ¿Asisti&oacute;?
                            <input type="checkbox" checked={data.attendedPL} onClick={context.attendedMark.bind(context)} data-argument="AttendedPL" value={data.id} />
                        </div>
                    </div>
                </div>
                <div className="group">
                    <b></b>
                    <a href={`https://api.whatsapp.com/send/?phone=57${data.contact}&text=Hola ${data.name}`} target="_blank" className="action btn whatsapp"></a>
                    <input type="button" onClick={context.openDetail.bind(context)} data-value={data.id} className="action btn more" title="Ver más detalle" />
                    <input type="button" onClick={context.openModalPayments.bind(context)} data-value={data.id} className="action btn paying" title="Historico de pagos" />

                    <input type="button" onClick={() => { window.open('/ficha-avanzado?email=' + data.email, '_blank') }} data-value={data.id} className="action btn advance" title="Formulario avanzado" />
                    <input type="button" onClick={() => { window.open('/ficha-pl?email=' + data.email, '_blank') }} data-value={data.id} className="action btn pl" title="Formulario programa de liderazgo" />
                    <a data-toggle="modal" data-target="#delete" data-value={data.id} onClick={(e) => { context.setState({ clientId: data.id }) }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" class="bi bi-trash-fill" viewBox="0 0 16 16">
                            <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z" />
                        </svg>
                    </a>
                </div>
            </div>))
        } else {
            return <div>Sin resultados, intente selecionando otra proceso.</div>;
        }
    }

    render() {

        const content = this.state.loading ? <h2>Cargando...</h2> : (this.state.isGrid ? RegisteredUsers.renderViewGrid(this) : RegisteredUsers.renderDesktop(this));
        const scarp = this.state.showScarp ? <TemplateScarapela typeProcess={this.state.typeProcess} data={this.state.showScarp} /> : null;

        const loadingPrint = this.state.printing ? <h4>Imprimiendo, por favor espere</h4> : null;

        return (<div id="wrappRegisteredUsers">

        <h2>Usuarios registrados</h2>

            <div className="filter">

                <fieldset className="row">
                    <legend className="col-md-12">Filtrar</legend>
                    <div className="col-md-6 mt-3">
                        <b>Proceso</b>
                        <ComboBox data={this.state.comboProcess} callBack={(event) => { this.setProcessId(event) }} id="comboProcessFilter" />
                    </div>
                    <div className="col-md-6 mt-3">
                        <b>Usuario</b>
                        <input type="text" id="searchUser" className="form-control" placeholder="Ingrese el nombre o el correo eletrónico del participante" onBlur={(event) => { this.handlerUser(event) }} />
                    </div>
                    <div className="col-md-6 mt-3">
                        <input type="checkbox" id="checkNoRegistry" onChange={(event) => { this.handlerCheck(event) }} />
                        <label for="checkNoRegistry">Usuarios sin registro que asistieron al básico</label>
                    </div>
                    <div className="col-md-6 mt-3">
                        <input type="checkbox" id="checkWithoutIdentity" onChange={(event) => { this.usersWithoutIdentity(event) }} />
                        <label for="checkWithoutIdentity">Usuarios sin confirmar indentidad</label>
                    </div>
                    <div className="col-md-12 mt-3">
                        <input type="button" className="btn btn-primary" value="Buscar" onClick={(event) => { this.get() }} />
                    </div>
                </fieldset>
            </div>

            <div className="mt-5">
                <input type="button" className="btn btn-primary" value="Descargar usuarios" onClick={(event) => { this.downloadClientsByProcess() }} hidden />
            </div>

            <input type="button" className="btn btn-success" value="Cambiar vista" onClick={() => { this.setState({ isGrid: !this.state.isGrid }) }} hidden />

            {
                /*
                this.state.search.EmptyRegistry ?
                    <input type="button" className="btn btn-success" value="Descargar reporte de usuarios sin registro" onClick={() => { this.sendUnregisteredUsers() }} />
            : null
                    */
            }

            <div class="modal-action-sections">

                {this.state.userList.length > 0 ? <button id="openModalActions" type="button" class="btn btn-primary" data-toggle="modal" data-target="#modalActions">
                    ¿Que quiere hacer?
                </button> : null}

                <div class="modal fade" id="modalActions" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="exampleModalLabel">¿Qu&eacute; quiere hacer?</h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <input type="button" value="Imprimir escarapela b&aacute;sico" title="Imprimir escarapela básico" data-type="Participante" onClick={this.print.bind(this)} />
                                <input type="button" value="Imprimir escarapela Avanzado" title="Imprimir escarapela Avanzado" data-type="Participante" onClick={this.print.bind(this)} />
                                <input type="button" value="Imprimir escarapela PL" title="Imprimir escarapela PL" data-type="Líder" onClick={this.print.bind(this)} />

                                <input type="button" value="Asisti&oacute; al b&aacute;sico" data-process="Basico" title="Asisti&oacute; al b&aacute;sico" onClick={this.markAsist.bind(this)} />
                                <input type="button" value="Asisti&oacute; al Avanzado" data-process="Avanzado" title="Asisti&oacute; al Avanzado" onClick={this.markAsist.bind(this)} />
                                <input type="button" value="Asisti&oacute; al PL" data-process="Pl" title="Asisti&oacute; al PL" onClick={this.markAsist.bind(this)} />
                                <input type="button" value="Descargar usuarios en excel" title="Descargar usuarios en excel" onClick={this.downloadClients.bind(this)} />

                                {this.state.loading || this.state.printing ? <h2>Procesando...</h2> : null}
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-dismiss="modal" >Cerrar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div >


            {loadingPrint}

            {this.state.data && this.state.data.length > 0 ? <div class="mt-3">

                <label for="selectedAllUser">
                    <input type="checkbox" id="selectedAllUser" onClick={(e) => {

                        if (e.currentTarget.checked) {
                            this.setState({ userList: this.state.data.map((a) => { return a.id }) })
                            document.querySelectorAll('.check-user').forEach((a, i) => { a.checked = true })
                            this.setState({ showScarp: this.state.data });
                        } else {
                            this.setState({ userList: [] })
                            document.querySelectorAll('.check-user').forEach((a, i) => { a.checked = false })
                            this.setState({ showScarp: [] });
                        }

                    }} />
                    Seleccionar todos los usuarios
                </label>

            </div> : null}



            {content}

            <ModalDetailUser data={this.state.userSelected} />
            <ModalMessageUser data={this.state.messages} Users={this.state.Users} clientId={this.state.clientId} />
            {this.state.clientId > -1 && this.state.isPayment ? <PaymentHistory ClientId={this.state.clientId} ResetClient={() => { this.setState({ clientId: -1, isPayment: false }) }} /> : null}

            {scarp}

            <div class="modal fade" id="delete" tabindex="-1" role="dialog" aria-labelledby="deleteLabel" aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="deleteLabel">Modal title</h5>
                            <button type="button" id="closeConfirmDelete" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            Está seguro de eliminar este usuario, se perderan los pagos e historial de mensajes.?
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                            <input type="button" class="btn btn-primary" value="Sí, eliminar" onClick={(a) => { this.deleteClient(a) }} />
                        </div>
                    </div>
                </div>
            </div>
        </div>)
    }
}